import { Component, computed, effect, input, output, viewChild } from '@angular/core';
import { RidContentCard } from '../rid-content-card/rid-content-card';

@Component({
  selector: 'rid-memory-card',
  imports: [RidContentCard],
  templateUrl: './rid-memory-card.html',
  host: {
    class: 'block',
  },
})
export class RidMemoryCard {
  text = input<string>();
  image = input<string>();
  audio = input<string | { pronounce: string }>();
  state = input<'HIDDEN' | 'FLIPPED' | 'CORRECT' | 'INCORRECT'>('HIDDEN');

  contentCard = viewChild.required<RidContentCard>('contentCard');

  isClickable = input<boolean>(false);
  clicked = output<void>();
  feedbackAnimEnd = output<void>();

  contentCardState = computed<'DEFAULT' | 'CORRECT' | 'INCORRECT' | 'DISABLED'>(() => {
    switch (this.state()) {
      case 'HIDDEN':
        return 'DISABLED';
      case 'FLIPPED':
        return 'DEFAULT';
      case 'CORRECT':
        return 'CORRECT';
      case 'INCORRECT':
        return 'INCORRECT';
    }
  });

  presentOnFlipped = effect(() => {
    if (this.state() === 'FLIPPED') {
      this.present();
    }
  });

  async present() {
    await this.contentCard().present();
  }
}
